module.exports = __webpack_public_path__ + "img/instagram-story.9e555740.svg";